import { type ReactNode } from 'react'
import { Button } from '@/components/Button'
import { Form } from '@/components/Form'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentDescription,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetSection,
} from '@/components/ModalSheet'

export interface AddCustomerToWorkspaceDialogProps {
  showing: boolean
  onClose: () => void
  onSubmit: () => void
  isSubmitPending: boolean
  /**
   * The form fields.
   */
  children: ReactNode
}

export function AddCustomerToWorkspaceDialog({
  showing,
  onClose,
  onSubmit,
  isSubmitPending,
  children,
}: AddCustomerToWorkspaceDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isSubmitPending ? undefined : onClose}
      disableCloseOnOutsideClick
    >
      <ModalSheetHeader withCloseButton />

      <ModalSheetContent>
        <ModalSheetSection horizontallySpaced>
          <ModalSheetContentTitle>
            Add customer to workspace
          </ModalSheetContentTitle>
          <ModalSheetContentDescription compact>
            Select the workspace to add this customer to. A magic link
            invitation will be sent to their email address.
          </ModalSheetContentDescription>
        </ModalSheetSection>

        <ModalSheetSection spaced>
          <Form id="addCustomerToWorkspace" onSubmit={onSubmit}>
            {children}
          </Form>
        </ModalSheetSection>
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Cancel"
            variant="default"
            onPress={onClose}
            isDisabled={isSubmitPending}
          />
          <Button
            label="Send Invitation"
            type="submit"
            form="addCustomerToWorkspace"
            variant="primary"
            isDisabled={isSubmitPending}
            isPending={isSubmitPending}
            testId="add-customer-to-workspace-submit"
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
